import {Component, OnInit, Input} from '@angular/core';
import {FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import {IAgentMonitor, IChannel } from '../../common/monitor';
import {IForma, ITipificacionLog, IFormaPregunta } from '../../common/forma';
import * as moment from 'moment';
import * as _ from 'lodash';

import {FormasService } from '../_services/formas.service';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Component({
    selector: 'agente-tipificacion',
    template: require('./tipificacion.component.html')
})
export class TipificacionComponent implements OnInit {
    
    private titulo: { texto: string, subtitulo: string };
    private llamada: IChannel;
    @Input() agente: IAgentMonitor;
    
    private frm: FormGroup;
    
    constructor(private $forma: FormasService, private fb: FormBuilder) {}

    ngOnInit() {
        this.frm = this.fb.group({
            log: this.fb.array([])            
        });
    }
    
    asignarLlamada(llamada: IChannel) {
        this.llamada = llamada ? {...llamada} : undefined; // _.cloneDeep(this.agente.channel);
        const preguntasFormArray = <FormArray>this.frm.controls['log'];
        
        for (let i = 0; i < preguntasFormArray.length; i++) {
            preguntasFormArray.at(i).patchValue({
                callid: this.llamada.UniqueID,
                fecha: new Date()
            })
        }
    }
    
    lanzarForma(forma: IForma, llamada: IChannel) {
        
        this.titulo = {
            texto: forma.titulo,
            subtitulo: forma.descripcion
        };
        Observable.of(forma.id)
            .switchMap(id => this.$forma.getPreguntasFormulario(id))
            .do(() => this.llamada = llamada ? {...llamada} : undefined)
            .subscribe(
                preguntas => {
                    
                    this.ngOnInit();
                    let logs = <FormArray> this.frm.controls['log'];
                    
                    _.sortBy(preguntas, 'orden').forEach(p => {
                        let log = this.fb.group({
                            callid: '',
                            idformulario: '',
                            fecha: '',
                            autor: '',
                            pregunta: '',
                            respuesta: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                            tipo: '',
                            opciones: this.fb.array([])
                        });
                        
                        // Queda libre tipo y respuesta para ser diligenciado
                        log.patchValue({
                            callid: (!!llamada ? llamada.UniqueID : 'no-call_' + ObjectID()),
                            idformulario: p.idformulario,
                            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
                            autor: this.agente.idagente,
                            pregunta: p.pregunta,
                            tipo: p.tipo,
                            respuesta: ''
                        });
                        
                        let opciones = <FormArray> log.controls['opciones'];
                        _.sortBy((p.respuestas as {tipo: string, respuesta: string}[]), 'tipo').reverse().forEach(r => {
                            let _r = this.fb.group({
                                tipo: '',
                                respuesta: ''
                            });
                            _r.setValue(r);
                            opciones.push(_r);
                        })
                        
                        logs.push(log);
                        
                    });
                    $('#agenteTipificacionModal').modal({
                        backdrop: 'static',
                        keyboard: false
                    });
                }
            )
    }
    
    /**
     * @description Guardar el log en DB
     * @param formas: ITipificacionLog[]
     */
    guardarFormulario(formas: ITipificacionLog[]) {                
        this.$forma.guardarLog(formas)
            .subscribe(
                res => console.log(res),
                err => console.warn(err)
            )
        
        $('#agenteTipificacionModal').modal('hide');
    }
} 

export function ObjectID(): string {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/agente/tipificacion.component.ts